import axios from 'axios';

const getList = params => axios.get('user/notificacao', { params });

const create = (notificacao) => {
  if (notificacao.id) {
    return axios.put(`user/notificacao/${notificacao.id}`, notificacao);
  }
  return axios.post('user/notificacao', notificacao);
};

export default {
  getList,
  create,
};
